var cov_1hkepz0y6u = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/curry.ts",
      hash = "ba895a4d1c59fa76c0a4fb368d6076af0893a13a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/curry.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 15
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 18
        },
        end: {
          line: 5,
          column: 3
        }
      },
      "2": {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 81
        }
      },
      "3": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 16
        }
      },
      "4": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 30,
          column: 19
        }
      },
      "5": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 19
        }
      },
      "6": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 15
          },
          end: {
            line: 2,
            column: 16
          }
        },
        loc: {
          start: {
            line: 2,
            column: 33
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 3,
            column: 18
          },
          end: {
            line: 3,
            column: 19
          }
        },
        loc: {
          start: {
            line: 3,
            column: 40
          },
          end: {
            line: 5,
            column: 3
          }
        },
        line: 3
      },
      "2": {
        name: "curry2",
        decl: {
          start: {
            line: 29,
            column: 16
          },
          end: {
            line: 29,
            column: 22
          }
        },
        loc: {
          start: {
            line: 29,
            column: 90
          },
          end: {
            line: 31,
            column: 1
          }
        },
        line: 29
      },
      "3": {
        name: "curry3",
        decl: {
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 33,
            column: 22
          }
        },
        loc: {
          start: {
            line: 33,
            column: 106
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 33
      },
      "4": {
        name: "curry4",
        decl: {
          start: {
            line: 37,
            column: 16
          },
          end: {
            line: 37,
            column: 22
          }
        },
        loc: {
          start: {
            line: 39,
            column: 39
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 11
          },
          end: {
            line: 4,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 4,
            column: 35
          },
          end: {
            line: 4,
            column: 54
          }
        }, {
          start: {
            line: 4,
            column: 57
          },
          end: {
            line: 4,
            column: 81
          }
        }],
        line: 4
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1hkepz0y6u.s[0]++;

// eslint-disable-next-line no-underscore-dangle
var _curry = function _curry(fn) {
  cov_1hkepz0y6u.f[0]++;
  cov_1hkepz0y6u.s[1]++;

  var curried = function curried() {
    cov_1hkepz0y6u.f[1]++;
    cov_1hkepz0y6u.s[2]++;

    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    return t.length >= fn.length ? (cov_1hkepz0y6u.b[0][0]++, fn.call.apply(fn, [this].concat(t))) : (cov_1hkepz0y6u.b[0][1]++, curried.bind.apply(curried, [this].concat(t)));
  };

  cov_1hkepz0y6u.s[3]++;
  return curried;
}; // Types


// Functions
export function curry2(fn) {
  cov_1hkepz0y6u.f[2]++;
  cov_1hkepz0y6u.s[4]++;
  return _curry(fn);
}
export function curry3(fn) {
  cov_1hkepz0y6u.f[3]++;
  cov_1hkepz0y6u.s[5]++;
  return _curry(fn);
}
export function curry4(fn) {
  cov_1hkepz0y6u.f[4]++;
  cov_1hkepz0y6u.s[6]++;
  return _curry(fn);
}